<template>
    <vue-autocomplete
        ref="autocomplete"
        v-model="university"
        placeholder="Высшее учебное заведение"
        :min="3"
        :required="true"
        :makeRequest="makeRequest"
        :onShouldRenderChild="renderChild"
        id="text"
        anchor="text"
        :on-select="onSelect"
        :on-paste="onPaste"
        :on-input="onInput"
    />
</template>

<script>
import {Beautify} from "../../../../directives/beautify";
import VAutocomplete from "@components/base/VAutocomplete";

export default {
    props: {
        item: {
            type: String,
            default: ''
        }
    },

    data: function () {
        return {
            university: this.item,
            request: null,
        };
    },

    components: {
        'vue-autocomplete': VAutocomplete,
    },

    methods: {
        makeRequest(query) {
            if (this.request) {
                this.request.cancel();
            }

            return new Promise((resolve, reject) => {
                this.request = this.axios.CancelToken.source();

                this.axios.post('/autocompleteUniversity', {q: query}, {
                    cancelToken: this.request.token
                }).then((response) => {
                    let result = response.data.suggestions;
                    resolve(result);
                }).catch(() => {});
            });
        },

        onSelect (data) {
            this.$refs.autocomplete.type = data.value;

            this.$emit('selected', data.value);
        },

        renderChild (data) {
            return `<div class="result-item"><span>${ data.data.text }</span></div>`;
        },

        onPaste(e) {
            this.$emit('paste', e.clipboardData.getData('text/plain'))
        },

        onInput (val) {
            this.$emit('selected', val);
        },
    },

    mounted() {
        let searchInput = this.$refs.autocomplete.$refs.input;

        Beautify.bind(
            searchInput,
            {value: 'capitalize itemclean rtrimpunctuation typograf withoutinitialspaces onlyonblur'}
        );

        searchInput.value = this.university;
        this.$refs.autocomplete.type = this.university;
    },

    watch: {
        item (newVal) {
            let oldVal = this.$refs.autocomplete.type;

            this.university = newVal;
            this.$refs.autocomplete.type = this.university;

            if (newVal !== oldVal) {
                this.$refs.autocomplete.json = [];
                this.$refs.autocomplete.getData(newVal);
            }
        }
    },
}
</script>
